const clubJoinBannerExample = [
  {
    nodeName: 'guest',
    'sling:resourceType': 'hm/components/loyalty/club',
    childrenNodes: [
      {
        activateEnable: 'false',
        preamble:
          '✓ 10% off when you join  \r\n✓ Unlimited free delivery \r\n✓ Points on all purchases\r\n✓ Offers and discounts\r\n✓ Exclusive events',
        headline: 'Members get more.',
        'sling:resourceType': 'hm/components/loyalty/club/awarenessbanner',
        backgroundColor: '#000000',
        hmclublogo: 'big',
        enablelogo: true,
        links: [
          {
            text: 'JOIN H&M CLUB',
            path: '/en_gb/club/join',
            backgroundColor: '#ffffff',
            color: '#000000',
            targetTemplate: 'loginclubjoin',
            linkname: 'join',
          },
          {
            text: 'Log In',
            path: '/en_gb/login',
            backgroundColor: '#000000',
            color: '#ffffff',
            targetTemplate: 'login',
            linkname: 'login',
          },
        ],
      },
      {
        preamble:
          'Your reward points for online purchases will be automatically registered when finalising your order. To collect reward points for in-store purcahses, show your digital H&M Club card via the H&M app to the cashier.\r\r',
        headline: 'H&M CLUB POINTS',
        earn: 'GET',
        pointUoM: ' 1 p',
        'sling:resourceType': 'hm/components/loyalty/club/points',
        vignette: 'Earn points on all purchases with H&M Club.',
        pointsJoin: '£1 =',
        textIsRich: 'true',
        enablevignette: true,
        backgroundColor: '#000000',
        links: [
          {
            text: 'REWARDS',
            path: '/en_gb/club/join',
            targetTemplate: 'loginclubjoin',
            linkname: 'rewards',
          },
          {
            text: 'CLUB INFORMATION',
            path: '/content/hmonline/en_gb/hmclub/info',
            targetTemplate: '/apps/hm/templates/content/loyalty/clubInformation',
            linkname: 'infoclub',
          },
        ],
      },
      {
        'sling:resourceType': 'hm/components/loyalty/club/aboutnews',
        dummy: true,
        scrImage:
          '/content/dam/HM Club/ladning_page/General/1208-SEASON-Desktop-Opening-Page-3x2-6.jpg',
        dummyNewsTitle: 'Welcome to the Club',
        enableGradientImage: false,
        enablePendingStyle: true,
        imageRatio: 1.5,
      },
      {
        'sling:resourceType': 'hm/components/loyalty/club/dummyvouchers',
        vouchers: [
          {
            'sling:resourceType': 'hm/components/loyalty/club/vouchers',
            headline: 'H&M Club Basics',
          },
          {
            type: 'standard',
            'sling:resourceType': 'hm/components/loyalty/club/standard-offerteaser',
            dummy: true,
            headline: 'Create an account at hm.com or download the H&M app to sign up.',
            vignette: 'JOIN H&M CLUB',
            imageRatio: 1.5,
            enableGradientImage: false,
            scrImage: '/content/dam/HM Club/ladning_page/Join Earn Spend/V2017/1.Join_hmclub.jpg',
          },
          {
            type: 'standard',
            'sling:resourceType': 'hm/components/loyalty/club/standard-offerteaser',
            dummy: true,
            headline:
              'Earn points on all purchases and use them to unlock offers, discounts and access to exclusive events.',
            vignette: 'EARN AND USE POINTS',
            imageRatio: 1.5,
            enableGradientImage: false,
            scrImage: '/content/dam/HM Club/ladning_page/Join Earn Spend/V2017/2.Earn_hmclub.jpg',
          },
          {
            type: 'standard',
            'sling:resourceType': 'hm/components/loyalty/club/standard-offerteaser',
            dummy: true,
            headline:
              'Find your H&M Club offers and benefits under the H&M Club tab in the app or at hm.com.',
            vignette: 'CHOOSE YOUR REWARDS',
            imageRatio: 1.5,
            enableGradientImage: false,
            scrImage: '/content/dam/HM Club/ladning_page/Join Earn Spend/V2017/3.Spend_hmclub.jpg',
          },
        ],
      },
    ],
  },
  {
    nodeName: 'jcr:content',
    'jcr:title': 'H&M Club',
    newsScopebartitle: 'News',
    voucherScopebarstitle: 'Vouchers',
    pageTitle: 'H&M Club',
    analyticsCategory: 'CLUB_STARTPAGE',
    coremetricsPageId: 'Club : Startpage',
    'sling:resourceType': 'nonCqType_PageProperties',
    preshoppingEndedMessage: 'We’re sorry… Pre-sale just ended.',
  },
  {
    'sling:resourceType': 'nonCqType_Breadcrumb',
    links: [
      {
        text: 'HM.com',
        targetTemplate: '/apps/hm/templates/content/homepage',
        path: '/content/hmonline/en_gb/index',
      },
      {
        text: 'H&M Club',
        targetTemplate: '/apps/hm/templates/content/loyalty/club',
        path: '/content/hmonline/en_gb/hmclub',
      },
    ],
  },
]

export default clubJoinBannerExample
